import { Entity } from '@sqior/js/entity';
import { EntityModel, Interface } from '@sqior/js/meta';
import { LanguageEntities, LanguageInterfaces } from './language-definitions';

/* Language Gender */

export enum Gender {
  Male = 'male',
  Female = 'female',
  Neuter = 'neuter',
}
export type GenderEntity = Entity & { gender: Gender };
export const GenderModel: EntityModel = {
  type: LanguageEntities.Gender,
  props: ['gender'],
  keys: ['gender'],
};
export function makeGender(gender: Gender): GenderEntity {
  return { entityType: LanguageEntities.Gender, gender: gender };
}

/* Grammatical Case */

export enum GrammaticalCase {
  Nominative = 'nominative',
  DativeSoft = 'dative-soft',
}
export type GrammaticalCaseEntity = Entity & { grammaticalCase: string };
export const GrammaticalCaseModel: EntityModel = {
  type: LanguageEntities.Case,
  props: ['grammaticalCase'],
};
export function makeGrammaticalCase(grammaticalCase: string): GrammaticalCaseEntity {
  return { entityType: LanguageEntities.Case, grammaticalCase: grammaticalCase };
}

/* Preposition if something is inside */
export const InsidePrepositionModel: Interface = {
  type: LanguageInterfaces.InsidePreposition,
  requires: LanguageEntities.AnonymizedText,
};
/* Preposition if something is put into */
export const IntoPrepositionModel: Interface = {
  type: LanguageInterfaces.IntoPreposition,
  requires: LanguageEntities.AnonymizedText,
};
/* Preposition if something is picked up from */
export const FromPrepositionModel: Interface = {
  type: LanguageInterfaces.FromPreposition,
  requires: LanguageEntities.AnonymizedText,
};
/* Preposition if someone is going to */
export const ToPrepositionModel: Interface = {
  type: LanguageInterfaces.ToPreposition,
  requires: LanguageEntities.AnonymizedText,
};
